import { DiscountStructureItemType } from '../../../../models/discount-structure-item-type';
import client from '../../client';

const accountDiscountStructure = async (
  sessionId: string
): Promise<DiscountStructureItemType[]> => {
  const { data } = await client.post<{
    discountStructure: Record<number, string>;
  }>('/account/discount-structure', {
    provider: 0,
    sessionId,
  });

  return Object.entries(data.discountStructure).map(
    (value: [string, string]) => ({
      group: parseInt(value[0], 10),
      percentage: parseFloat(value[1]),
    })
  );
};

export default accountDiscountStructure;
